import React from "react";
import { HeaderTitle, HeaderWrapper } from "./DashboardDetailHeaderStyle";
import BackLinkIcon from "assets/icons/left_arrow.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { changeSearchListType } from "redux/modules/dashboard";

const DashboardDetailHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <HeaderWrapper>
      <img
        src={BackLinkIcon}
        alt="Back Link button"
        onClick={() => {
          dispatch(changeSearchListType());
          navigate("/dashboard/search");
        }}
      />
      <HeaderTitle>꽃 상세보기</HeaderTitle>
    </HeaderWrapper>
  );
};

export default DashboardDetailHeader;
